import React from 'react';
import PropTypes from 'prop-types';
import { CurrencyContext, FormatCurrency } from 'day8-ui';

const Component = ({ baseCurrency, isPaymentPage, className }) => (
  <CurrencyContext.Consumer>
    {context => context.currency !== baseCurrency && (
      <div className={`${className}`}>
        <p className="dui-text-gray-400 dui-text-sm">
        *The price in {context.currency} is based on today&rsquo;s exchange rate:{' '}
          <FormatCurrency amount={1} baseCurrency={baseCurrency} showCurrency={baseCurrency} round={false} /> ={' '}
          <FormatCurrency amount={1} baseCurrency={baseCurrency} round={false} />. Please note: any
        future payments will adhere to the exchange rate of the day
        </p>
        {isPaymentPage && <p className="dui-text-gray-400 dui-text-sm dui-mt-4">Please note: your invoice will be in Euros and any future payments made will adhere to the exchange rate of the day</p>}
      </div>
    )}
  </CurrencyContext.Consumer>
);

Component.propTypes = {
  baseCurrency: PropTypes.string.isRequired,
  isPaymentPage: PropTypes.bool,
  className: PropTypes.string
};

export default Component;
